module.exports = __webpack_public_path__ + "img/img-1.4f7d8b27.jpg";